import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { Formik, Form } from 'formik'
import { isEmpty } from 'lodash'
import * as Yup from 'yup'

import TipConfigurationsBody from 'components/VenueSettings/Drawers/TipConfigurations/TipConfigurationsBody'
import Modal from 'components/Modal'

import { getCurrentVenueUuid } from 'store/Venues/selector'
import { createVenueSettingsNew } from 'store/Settings/actions'
import { fillArrayWithNullToLength } from 'utils/fillArrayWithNullToLength'
import { getPreparedSettingsData } from 'utils/venueSettings/apiDataPreparation'
import venueSettingsValidation from 'components/VenueSettings/utils/validation'

const TipConfigurationsForm = ({
  setModalType,
  transformedSettingsValues,
}) => {
  const [showValidationErrors, setShowValidationErrors] =
    useState(false)

  const currentVenueUuid = useSelector(getCurrentVenueUuid)
  const dispatch = useDispatch()

  const initialValues = {
    tip_should_include_charges:
      transformedSettingsValues?.tip_should_include_charges ?? false,
    tip_should_include_promotions:
      transformedSettingsValues?.tip_should_include_promotions ??
      false,
    custom_tip_option:
      transformedSettingsValues?.custom_tip_option ?? false,
    tip_values: fillArrayWithNullToLength(
      transformedSettingsValues?.tip_values ?? [],
      4
    ),
    selected_tip_option:
      transformedSettingsValues?.selected_tip_option ?? null,
  }

  const validationSchema = Yup.object().shape({
    selected_tip_option: Yup.number()
      .nullable()
      .test({
        name: 'selected_tip_option',
        message: 'Required',
        test: (value) =>
          venueSettingsValidation.selectedTipOption(value),
      }),
    tip_values: Yup.array()
      .of(Yup.number().nullable())
      .test({
        name: 'tip_values',
        message: 'Tip values must be unique',
        test: (value) => venueSettingsValidation.tipValues(value),
      }),
  })

  const onClickSaveButton = () => {
    setShowValidationErrors(true)
  }

  const disableUpdateButton = (dirty, errors, isSubmitting) => {
    const disableButton =
      !dirty ||
      (showValidationErrors && !isEmpty(errors)) ||
      isSubmitting

    return disableButton
  }

  const onCloseModal = () => {
    setModalType(null)
  }

  const handleSubmit = (values) => {
    const venueSettingsToSend = getPreparedSettingsData(
      values,
      initialValues,
      currentVenueUuid
    )

    dispatch(createVenueSettingsNew(venueSettingsToSend)).then(() => {
      setModalType(null)
    })
  }

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      {({ dirty, errors, isSubmitting }) => {
        return (
          <Modal
            title="Tip Configurations"
            onClose={onCloseModal}
            className="-narrow"
            onRequestClose={onCloseModal}
          >
            <div className="modal-body">
              <Form>
                <div className="item-settings">
                  <TipConfigurationsBody
                    showValidationErrors={showValidationErrors}
                  />
                  <div className="btn-wrapper">
                    <button
                      className="btn -update"
                      onClick={onClickSaveButton}
                      disabled={disableUpdateButton(
                        dirty,
                        errors,
                        isSubmitting
                      )}
                      type="submit"
                      data-cy="button-save-tip-configurations"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </Modal>
        )
      }}
    </Formik>
  )
}

export default TipConfigurationsForm
